<template>
  <orders-page
    title="Today's Orders"
    :show-date-filter="false"
    :include-completed-orders="false"
    today-only
  />
</template>

<script>
import OrdersPage from "./index.vue"
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
  name: "todays-orders",
  components: {
    OrdersPage,
  },
  computed: {
    ...mapState(["soundOn", "settings", "onboardings"]),
    ...mapGetters(["currentOnboarding"]),
    shouldShowOnboarding() {
      return (
        !this.settings.disableOnboarding &&
        !this.onboardings.every(onboarding =>
          Object.values(onboarding.steps).every(step => step.completed)
        )
      )
    },
  },
  mounted() {
    if (this.shouldShowOnboarding) {
      this.$router.push({ name: "Onboarding" })
    } else if (!this.soundOn) {
      this.setNotification({
        message: "Sound is currently off",
        icon: "volume-high",
        browserOnly: true,
        forceBrowser: true,
      })
    }
  },
  methods: {
    ...mapMutations(["setNotification"]),
  },
}
</script>
